<script setup lang="ts">
import BrandHeader from "@/components/BrandHeader.vue";
import { PRODUCT_TITLE } from "@/constants/envs";

/**
 * 에러 페이지 전용 레이아웃
 * - 로그인 · 회원가입과 같은 틀이다: 위 기준 셸(`.auth-shell`) · 같은 폭 카드(`.auth-card`) · 카드 안 첫 요소로 로고 머리(`BrandHeader`) + 구분선.
 *   예전에는 로고 머리가 카드 밖 위에 있어 오류 카드가 인증 카드보다 약 180px 아래에 떴다(ui-refine-2 F-E-03).
 * - 제품명은 페이지 제목(h2)보다 위 계층이 아니므로 h1 대신 문단(`as="p"`)으로 두고 모양만 인증 화면 제목과 맞춘다(70차 UXE-16 — 이 파일 scoped
 *   에 있던 같은 규칙은 `BrandHeader` 로 옮겼다).
 * - 카드(`.card`)는 이 레이아웃이 그리고, 오류 페이지는 카드 안 본문(상태 배지 · 제목 · 설명 · 버튼 줄)만 그린다.
 * - 카드 본문(상태 배지 · 제목 · 설명 · 버튼 줄)은 로고 머리 · 로그인 카드와 같이 왼쪽 정렬이다. 예전에는 `is-center` 로 본문만 가운데라
 *   한 카드에 정렬축이 둘이었다(ui-seam 4차, d4).
 */
</script>

<template>
  <!-- data-ui-layout-root: 모달이 떠 있는 동안 overlay.ts 가 inert 를 거는 배경(74차 UXV74-06) -->
  <div class="auth-shell" data-ui-layout-root>
    <div class="auth-card">
      <div class="card">
        <BrandHeader
          as="p"
          :title="PRODUCT_TITLE"
          subtitle="조직적합성·직무적합성 설계 SaaS"
        />
        <RouterView />
      </div>
    </div>
  </div>
</template>
